export const promiseSerial = (functions: Function[]) => {
    const func = functions.shift();
    if (!func) return Promise.resolve();
    return func().then(() => promiseSerial(functions));
}
